<template>
  <div>
    <b-card>
      <b-row class="create_team mb-1">
        <b-col cols="7">
             <h5>{{ $t('CONFIGURED.DOC_RETENTION') }}</h5>
        </b-col>
        <b-col md="2">
          <b-form-select :plain="true" v-model="selectedDay" :options="availableDays"></b-form-select>
        </b-col>
        <b-col md="3">
          <vue-timepicker v-model="doc_retention_period" class="float-right" format="HH:mm" placeholder="HH:MM" close-on-complete></vue-timepicker>
        </b-col>
      </b-row>
      <div align="center">
        <b-btn size="md" variant="secondary" class="mt-auto" @click="updateRetentionPeriod"><i class="fa fa-save"></i> {{ $t('COMMON.SAVE') }}</b-btn>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

export default {
  props: ['retentionTime', 'retentionDaysCount'],
  data () {
    return {
      doc_retention_period: this.retentionTime,
      selectedDay: this.retentionDaysCount,
      availableDays: Array.from({length: 100}, (_, i) => i)
    }
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  components: { VueTimepicker },
  watch: {
    retentionTime: function (value) {
      this.doc_retention_period = value
    },
    retentionDaysCount: function (value) {
      this.selectedDay = value
    }
  },
  methods: {
    updateRetentionPeriod () {
      let duration = moment.duration(this.doc_retention_period)
      let time = moment.utc(duration.asMilliseconds()).format('HH:mm')
      let res = {
        time: `${this.selectedDay} days ${time}`
      }
      Vue.axios.post('/admin/accounts/update_doc_retention_period', res, {
        headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
        .catch(err => {
          console.log(err)
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
  background: #ebeff3;
  border-radius: 10px;
  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }
  .card-header {
    border-radius: 10px 10px 0 0;
    background-color: #e7e7e7;
    padding: 1rem;
  }
}
  
</style>



// WEBPACK FOOTER //
// src/components/settings/docRetention.vue